import { Box, Button, Typography } from "@material-ui/core";
import { useStyles } from "../../Styles/styles";

const QuickButtons = ({ selfOis, disabled, isOnIncident, setOfficerTime }) => {
  const classes = useStyles();

  let greenButton = "";
  if (selfOis) {
    if (selfOis?.enrouteAt) {
      greenButton = "enrouteAt";
    }
    if (selfOis?.onSceneAt) {
      greenButton = "onSceneAt";
    }
    if (selfOis?.clearedAt) {
      greenButton = "clearedAt";
    }
  }
  return (
    <Box
      flexGrow="2"
      id="quick-buttons"
      display="flex"
      justifyContent="space-evenly"
      alignItems="center"
      padding="20px 0"
    >
      <Button
        style={greenButton === "enrouteAt" ? { backgroundColor: "green" } : {}}
        disabled={disabled}
        data-cy="incident-header-bar-enroute-button"
        className={classes.navBarButtons}
        fontSize="3vw"
        variant="contained"
        onClick={e => setOfficerTime(e, "enrouteAt")}
      >
        <Typography
          style={{ fontSize: "1.45vw" }}
          className={classes.responsiveText}
        >
          En&nbsp;Route
        </Typography>
      </Button>
      <Button
        style={greenButton === "onSceneAt" ? { backgroundColor: "green" } : {}}
        disabled={disabled}
        data-cy="incident-header-bar-on-scene-button"
        className={classes.navBarButtons}
        fontSize="1.5vw"
        variant="contained"
        onClick={e => setOfficerTime(e, "onSceneAt")}
      >
        <Typography
          style={{ fontSize: "1.45vw" }}
          className={classes.responsiveText}
        >
          On&nbsp;Scene
        </Typography>
      </Button>
      <Button
        style={greenButton === "clearedAt" ? { backgroundColor: "green" } : {}}
        disabled={disabled || !isOnIncident}
        data-cy="incident-header-bar-call-cleared-button"
        className={classes.navBarButtons}
        fontSize="1.5vw"
        variant="contained"
        onClick={e => setOfficerTime(e, "clearedAt")}
      >
        <Typography
          style={{ fontSize: "1.45vw" }}
          className={classes.responsiveText}
        >
          Clear
        </Typography>
      </Button>
    </Box>
  );
};

export default QuickButtons;
